import { call, put, takeEvery } from "redux-saga/effects";
import {  toast } from 'react-toastify';
import { getFaq } from "redux/actions/UserFAQ";
import { GET_ADDFAQ_FAILED, GET_ADDFAQ_REQUESTED, GET_ADDFAQ_SUCCESS, GET_DELETEFAQ_FAILED, GET_DELETEFAQ_REQUESTED, GET_DELETEFAQ_SUCCESS, GET_FAQ_FAILED, GET_FAQ_REQUESTED, GET_FAQ_SECTION_FAILED, GET_FAQ_SECTION_REQUESTED, GET_FAQ_SECTION_SUCCESS, GET_FAQ_SUCCESS, GET_UPDATEFAQ_FAILED, GET_UPDATEFAQ_REQUESTED, GET_UPDATEFAQ_SUCCESS } from "resources/actionTypes";
import { addFaqApi, deleteFaqApi, faqApi, faqSectionApi, updateFaqApi } from "services/FAQService";
import store from "redux/store";
import { onLoaderTrigger } from "redux/actions/commonAction";

function* fetchFaq(action) {
  try {
    const payload = action.payload || {}
    const userFaq = yield call(faqApi,payload);
    yield put({ type: GET_FAQ_SUCCESS, userFaq: userFaq });
  } catch (e) {
    yield put({ type: GET_FAQ_FAILED, message: e.message });
    toast.error(e.message || 'Get  Faq Failed')
  }
}

export function* faqSaga() {
  yield takeEvery(GET_FAQ_REQUESTED, fetchFaq);
}

function* fetchAddFaq(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userAddFaq = yield call(addFaqApi, payload.userAddFaq);
  if(userAddFaq.success){
    yield put({ type: GET_ADDFAQ_SUCCESS, userAddFaq: userAddFaq });
    toast.success(userAddFaq.message);
    store.dispatch(onLoaderTrigger(false));
    store.dispatch(getFaq({role:userAddFaq.data.type,id:userAddFaq.data.parentId}));
  }else{
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: GET_ADDFAQ_FAILED, message: userAddFaq.message });
      toast.error(userAddFaq.message || 'Add FAQ failed');
  }
}
export function* addFaqSaga() {
  yield takeEvery(GET_ADDFAQ_REQUESTED, fetchAddFaq);
}

function* fetchUpdateFaq(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userUpdateFaq = yield call(updateFaqApi, payload.userUpdateFaq);
  if(userUpdateFaq.success){
    yield put({ type: GET_UPDATEFAQ_SUCCESS, userUpdateFaq: userUpdateFaq });
    toast.success(userUpdateFaq.message);
    store.dispatch(onLoaderTrigger(false));
    store.dispatch(getFaq({role:userUpdateFaq?.data?.type,id:userUpdateFaq?.data?.parentId}));
  }else{
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: GET_UPDATEFAQ_FAILED, message: userUpdateFaq.message });
      toast.error(userUpdateFaq.message || 'Update FAQ failed');
  }
}
export function* updateFaqSaga() {
  yield takeEvery(GET_UPDATEFAQ_REQUESTED, fetchUpdateFaq);
}

function* fetchDeleteFaq(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userDeleteFaq = yield call(deleteFaqApi, payload.userDeleteFaq);
  if(userDeleteFaq.success){
    yield put({ type: GET_DELETEFAQ_SUCCESS, userDeleteFaq: userDeleteFaq });
    toast.success(userDeleteFaq.message);
    store.dispatch(onLoaderTrigger(false));
    store.dispatch(getFaq({role:payload?.userDeleteFaq?.type,id:payload?.userDeleteFaq?.parentId}));
  }else{
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: GET_DELETEFAQ_FAILED, message: userDeleteFaq.message });
      toast.error(userDeleteFaq.message || 'Delete FAQ failed');
  }
}
export function* deleteFaqSaga() {
  yield takeEvery(GET_DELETEFAQ_REQUESTED, fetchDeleteFaq);
}


function* fetchFaqSection(action){
    try{
        const payload = action.payload || {}
        const userFaqSection = yield call(faqSectionApi,payload);
        yield put ({ type:GET_FAQ_SECTION_SUCCESS,userFaqSection:userFaqSection});
    } catch (e) {
        yield put ({ type:GET_FAQ_SECTION_FAILED,message:e.message });
        toast.error(e.message || 'Get Faq Section Failed')
    }
}
export function* faqSectionSaga(){
    yield takeEvery(GET_FAQ_SECTION_REQUESTED,fetchFaqSection)
}